import { SharedState } from '@trello/shared-state';

export interface LocationState {
  pathname: string;
  search: string;
  hash: string;
}

const { pathname, search, hash } = window.location;
export const locationState = new SharedState<LocationState>({
  pathname,
  search,
  hash,
});
